import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[componentHost]',
    standalone: false
})
export class ComponentHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
        
    }
}
